/* eslint-disable */
export default {
    error_page_not_found: "Page not found!",
    error_page_not_found_title: "Page not found",
    error_page_not_found_body: "The page you requested could not be found. ",
    error_ltpimpact_landing_title: "This service is no longer available",
    error_ltpimpact_landing_content: "Unfortunately, this site is no longer accessible. Contact the Client Center of LTP via <a href=\"mailto:online@ltp.nl\">online@ltp.nl</a> or via 020 30 50 438."
};
